import { Component } from '@angular/core';

@Component({
  selector: 'app-loading',
  standalone: true,
  template: `
    <div class="loading-container">
      <div class="loading-content">
        <div class="spinner-sm"></div>
        <h2 class="loading-title">Validando acceso...</h2>
        <p class="loading-message">
          Por favor espera mientras verificamos tu información
        </p>
      </div>
    </div>
  `,
  styles: [
    `
      .loading-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        padding: 20px;
        background-color: #f8f9fa;
      }

      .loading-content {
        text-align: center;
        max-width: 400px;
        width: 100%;
      }

      .spinner-sm {
        margin: 0 auto 24px;
      }

      .loading-title {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        margin-bottom: 12px;
      }

      .loading-message {
        font-size: 14px;
        color: #666;
        line-height: 1.5;
        margin: 0;
      }
    `,
  ],
})
export class LoadingComponent {}
